package io.github.jangalinski.pages._2014._09._23

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initRedirectGitRemotesPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("2014/09/23/RedirectGitRemotes.md", FrontMatterElement.Builder { addScalar("title", "Redirect to new github location"); addScalar("subtitle", "nice to know"); addScalar("date", "2014-09-23"); }))
}

@Page("/2014/09/23/redirect-git-remotes")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun RedirectGitRemotesPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("No need to fear renaming your github repos, if you do it right, the old location will forward to the new name/location, as documented in ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://help.github.com/articles/how-to-transfer-a-repository#redirects-and-git-remotes") {
            org.jetbrains.compose.web.dom.Text("this article")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("When a repository is transferred, all links to the previous location are automatically redirected to the new location. In addition to redirecting web traffic, all git clone, git fetch, or git push operations targeting the previous location will continue to function as if made on the new location. However, this can be somewhat confusing, so we strongly recommend updating any existing local clones to point to the new repository URL.")
        }
    }
}
